<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="24" viewBox="0 0 28 24" v-on="$listeners">
    <defs>
        <clipPath id="clip-Burger">
        <rect width="28" height="24"/>
        </clipPath>
    </defs>
    <g id="Burger" clip-path="url(#clip-Burger)">
        <g id="Rectangle_6087" data-name="Rectangle 6087" transform="translate(4 5)" :stroke="color" stroke-width="2">
        <rect width="20" height="3" rx="1.5" stroke="none"/>
        <rect x="1" y="1" width="18" height="1" rx="0.5" fill="none"/>
        </g>
        <g id="Rectangle_6088" data-name="Rectangle 6088" transform="translate(4 11)" :stroke="color" stroke-width="2">
        <rect width="20" height="3" rx="1.5" stroke="none"/>
        <rect x="1" y="1" width="18" height="1" rx="0.5" fill="none"/>
        </g>
        <g id="Rectangle_6089" data-name="Rectangle 6089" transform="translate(4 17)" :stroke="color" stroke-width="2">
        <rect width="13" height="3" rx="1.5" stroke="none"/>
        <rect x="1" y="1" width="11" height="1" rx="0.5" fill="none"/>
        </g>
    </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconBurger',
    mixins: [Colorable],
};
</script>
